import React from "react";
import locale from "../../locale";

function Member(props)
{
	const memberName = locale.getProperty(props, 'fullname');
	const memberDescription = locale.getProperty(props, 'description');

	const avatarStyle = {};
	if (props.photo) {
		avatarStyle.backgroundImage = `url(${props.photo})`;
	}

	let memberType = 'inline';
	if (props.settings.memberComponent === 'block') {
		memberType = 'block';
	}

	return (
		<article className={`member-type-${memberType}`}>
			<div className="member-avatar" style={avatarStyle} />
			<p className="member-name" style={props.settings.styleName}>{memberName}</p>
			<p className="member-info" style={props.settings.styleDescription}>{memberDescription}</p>
		</article>
	);
}

class LayoutMembers extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.state = {
			members: null,
		};
	}

	componentDidMount()
	{
		const {event} = this.props;
		const members = [];

		event.stream.forEach((stream) => {
			stream.episode.forEach((episode) => {
				episode.speakers.forEach((member) => {
					if (members.find(m => m.id === member.id)) {
						return;
					}
					members.push(member);
				});
				episode.moderators.forEach((member) => {
					if (members.find(m => m.id === member.id)) {
						return;
					}
					members.push(member);
				});
			});
		});
		this.setState({members});
	}

	render()
	{
		const {members} = this.state;
		const {settings} = this.props;

		if (!settings) {
			return null;
		}

		if (!members || !members.length) {
			return null;
		}

		return (
			<aside className="section-members" id="members" style={settings.style}>
				<h1 style={settings.styleHeader}>
					{locale.getProperty(settings, 'title') || locale.get('layer-members-title')}
				</h1>
				<div className="landing-nav-section-text" style={settings.styleContent}>
					{members.map((member, index) => <Member key={index} {...member} settings={settings} />)}
				</div>
			</aside>
		);
	}
}

export default LayoutMembers;
